import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll to the top of the page on every route change.
 *
 * Fixes a mobile bug where navigating via bottom-nav (e.g. Dashboard → Orders)
 * kept the previous scrollY — landing users in blank whitespace above the fixed
 * bottom nav and making the destination page appear "not loaded".
 *
 * Skips the scroll reset when navigating to the same pathname (e.g. filter
 * state changes on the same page).
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser's automatic scroll restoration so we control it explicitly.
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
